var map = {
	"./": 285,
	"./App.test": 424,
	"./App.test.js": 424,
	"./Root": 306,
	"./Root.js": 306,
	"./assets/custom.css": 467,
	"./assets/fonts/FontAwesome.otf": 854,
	"./assets/fonts/Simple-Line-Icons.eot": 855,
	"./assets/fonts/Simple-Line-Icons.svg": 856,
	"./assets/fonts/Simple-Line-Icons.ttf": 857,
	"./assets/fonts/Simple-Line-Icons.woff": 858,
	"./assets/fonts/Simple-Line-Icons.woff2": 859,
	"./assets/fonts/fa-brands-400.eot": 860,
	"./assets/fonts/fa-brands-400.svg": 861,
	"./assets/fonts/fa-brands-400.ttf": 862,
	"./assets/fonts/fa-brands-400.woff": 863,
	"./assets/fonts/fa-brands-400.woff2": 864,
	"./assets/fonts/fa-regular-400.eot": 865,
	"./assets/fonts/fa-regular-400.svg": 866,
	"./assets/fonts/fa-regular-400.ttf": 867,
	"./assets/fonts/fa-regular-400.woff": 868,
	"./assets/fonts/fa-regular-400.woff2": 869,
	"./assets/fonts/fa-solid-900.eot": 870,
	"./assets/fonts/fa-solid-900.svg": 871,
	"./assets/fonts/fa-solid-900.ttf": 872,
	"./assets/fonts/fa-solid-900.woff": 873,
	"./assets/fonts/fa-solid-900.woff2": 874,
	"./assets/fonts/fontawesome-webfont.eot": 875,
	"./assets/fonts/fontawesome-webfont.svg": 876,
	"./assets/fonts/fontawesome-webfont.ttf": 877,
	"./assets/fonts/fontawesome-webfont.woff": 878,
	"./assets/fonts/fontawesome-webfont.woff2": 879,
	"./assets/img/cart-empty.png": 469,
	"./assets/img/favicons/favicon-128x128.png": 880,
	"./assets/img/favicons/favicon-144x144.png": 881,
	"./assets/img/favicons/favicon-16x16.png": 882,
	"./assets/img/favicons/favicon-192x192.png": 883,
	"./assets/img/favicons/favicon-32x32.png": 884,
	"./assets/img/favicons/favicon-36x36.png": 885,
	"./assets/img/favicons/favicon-48x48.png": 886,
	"./assets/img/favicons/favicon-512x512.png": 887,
	"./assets/img/favicons/favicon-96x96.png": 888,
	"./assets/img/icons/cancel-order.svg": 470,
	"./assets/img/icons/confirm-action.svg": 471,
	"./assets/img/icons/wallet.svg": 472,
	"./assets/img/loading-food.gif": 473,
	"./assets/img/login-header.png": 889,
	"./assets/img/logos/logo-min.png": 234,
	"./assets/img/logos/logo.png": 357,
	"./assets/img/logos/time2dine-left.png": 422,
	"./assets/img/order-canceled.png": 474,
	"./assets/img/order-onway.gif": 295,
	"./assets/img/order-placed.gif": 165,
	"./assets/img/order-preparing.gif": 243,
	"./assets/img/ready-for-selfpickup.gif": 475,
	"./assets/img/splash/splash.jpg": 423,
	"./assets/img/splash/splash.psd": 890,
	"./assets/img/various/156662819939lzR3gB2i-sm.png": 891,
	"./assets/img/various/156662819939lzR3gB2i.png": 892,
	"./assets/img/various/avatars/user1.gif": 893,
	"./assets/img/various/avatars/user10.gif": 894,
	"./assets/img/various/avatars/user2.gif": 476,
	"./assets/img/various/avatars/user3.gif": 895,
	"./assets/img/various/avatars/user4.gif": 896,
	"./assets/img/various/avatars/user5.gif": 897,
	"./assets/img/various/avatars/user6.gif": 898,
	"./assets/img/various/avatars/user7.gif": 899,
	"./assets/img/various/avatars/user8.gif": 900,
	"./assets/img/various/avatars/user9.gif": 901,
	"./assets/img/various/bg-design.png": 902,
	"./assets/img/various/bg-pattern-inverse.png": 903,
	"./assets/img/various/bg-pattern.png": 904,
	"./assets/img/various/blue.png": 905,
	"./assets/img/various/cod.png": 477,
	"./assets/img/various/current-location-marker.png": 906,
	"./assets/img/various/default-image.png": 379,
	"./assets/img/various/default_restaurant.jpg": 380,
	"./assets/img/various/delivery-bike.png": 478,
	"./assets/img/various/delivery-map-marker.png": 907,
	"./assets/img/various/dragable-marker.png": 908,
	"./assets/img/various/dragable-markerv2.png": 479,
	"./assets/img/various/explore-bg.png": 480,
	"./assets/img/various/free-software-development-agreement.doc": 909,
	"./assets/img/various/header-bg-shape.svg": 910,
	"./assets/img/various/marker-delivery.png": 911,
	"./assets/img/various/marker-home.png": 912,
	"./assets/img/various/marker-restaurant.png": 913,
	"./assets/img/various/non-veg-icon.png": 148,
	"./assets/img/various/paystack.png": 914,
	"./assets/img/various/powered_by_google_on_white.png": 481,
	"./assets/img/various/pure-veg.png": 381,
	"./assets/img/various/razorpay.png": 482,
	"./assets/img/various/restaurant-map-marker.png": 915,
	"./assets/img/various/review-bg.png": 916,
	"./assets/img/various/selected-location-marker.png": 917,
	"./assets/img/various/spinner.svg": 382,
	"./assets/img/various/stripe.png": 483,
	"./assets/img/various/veg-icon.png": 149,
	"./assets/img/various/viva_wallet_logo.svg": 918,
	"./assets/img/various/viva_wallet_simple_logo.jpeg": 484,
	"./assets/img/various/waiter.gif": 485,
	"./assets/img/various/wallet.png": 383,
	"./assets/main.css": 468,
	"./components/App": 207,
	"./components/App.js": 207,
	"./components/CheckVersion": 175,
	"./components/CheckVersion/": 175,
	"./components/CheckVersion/index": 175,
	"./components/CheckVersion/index.js": 175,
	"./components/Delivery": 244,
	"./components/Delivery/": 244,
	"./components/Delivery/DeliveryDesktop": 177,
	"./components/Delivery/DeliveryDesktop/": 177,
	"./components/Delivery/DeliveryDesktop/index": 177,
	"./components/Delivery/DeliveryDesktop/index.js": 177,
	"./components/Delivery/ShareLiveLocation": 176,
	"./components/Delivery/ShareLiveLocation/": 176,
	"./components/Delivery/ShareLiveLocation/index": 176,
	"./components/Delivery/ShareLiveLocation/index.js": 176,
	"./components/Delivery/index": 244,
	"./components/Delivery/index.js": 244,
	"./components/Desktop": 169,
	"./components/Desktop/": 169,
	"./components/Desktop/Footer": 118,
	"./components/Desktop/Footer/": 118,
	"./components/Desktop/Footer/index": 118,
	"./components/Desktop/Footer/index.js": 118,
	"./components/Desktop/Hero": 171,
	"./components/Desktop/Hero/": 171,
	"./components/Desktop/Hero/index": 171,
	"./components/Desktop/Hero/index.js": 171,
	"./components/Desktop/StoreAchievements": 172,
	"./components/Desktop/StoreAchievements/": 172,
	"./components/Desktop/StoreAchievements/index": 172,
	"./components/Desktop/StoreAchievements/index.js": 172,
	"./components/Desktop/V1": 170,
	"./components/Desktop/V1/": 170,
	"./components/Desktop/V1/index": 170,
	"./components/Desktop/V1/index.js": 170,
	"./components/Desktop/index": 169,
	"./components/Desktop/index.js": 169,
	"./components/Mobile": 173,
	"./components/Mobile/": 173,
	"./components/Mobile/Account": 245,
	"./components/Mobile/Account/": 245,
	"./components/Mobile/Account/Addresses": 246,
	"./components/Mobile/Account/Addresses/": 246,
	"./components/Mobile/Account/Addresses/AddressList": 119,
	"./components/Mobile/Account/Addresses/AddressList/": 119,
	"./components/Mobile/Account/Addresses/AddressList/index": 119,
	"./components/Mobile/Account/Addresses/AddressList/index.js": 119,
	"./components/Mobile/Account/Addresses/index": 246,
	"./components/Mobile/Account/Addresses/index.js": 246,
	"./components/Mobile/Account/Logout": 178,
	"./components/Mobile/Account/Logout/": 178,
	"./components/Mobile/Account/Logout/index": 178,
	"./components/Mobile/Account/Logout/index.js": 178,
	"./components/Mobile/Account/Orders": 247,
	"./components/Mobile/Account/Orders/": 247,
	"./components/Mobile/Account/Orders/OrderList": 183,
	"./components/Mobile/Account/Orders/OrderList/": 183,
	"./components/Mobile/Account/Orders/OrderList/OrderCancelPopup": 184,
	"./components/Mobile/Account/Orders/OrderList/OrderCancelPopup/": 184,
	"./components/Mobile/Account/Orders/OrderList/OrderCancelPopup/index": 184,
	"./components/Mobile/Account/Orders/OrderList/OrderCancelPopup/index.js": 184,
	"./components/Mobile/Account/Orders/OrderList/index": 183,
	"./components/Mobile/Account/Orders/OrderList/index.js": 183,
	"./components/Mobile/Account/Orders/RatingAndReview": 248,
	"./components/Mobile/Account/Orders/RatingAndReview/": 248,
	"./components/Mobile/Account/Orders/RatingAndReview/index": 248,
	"./components/Mobile/Account/Orders/RatingAndReview/index.js": 248,
	"./components/Mobile/Account/Orders/index": 247,
	"./components/Mobile/Account/Orders/index.js": 247,
	"./components/Mobile/Account/UserInfo": 179,
	"./components/Mobile/Account/UserInfo/": 179,
	"./components/Mobile/Account/UserInfo/AvatarSelector": 180,
	"./components/Mobile/Account/UserInfo/AvatarSelector/": 180,
	"./components/Mobile/Account/UserInfo/AvatarSelector/index": 180,
	"./components/Mobile/Account/UserInfo/AvatarSelector/index.js": 180,
	"./components/Mobile/Account/UserInfo/index": 179,
	"./components/Mobile/Account/UserInfo/index.js": 179,
	"./components/Mobile/Account/UserMenu": 181,
	"./components/Mobile/Account/UserMenu/": 181,
	"./components/Mobile/Account/UserMenu/PagePopup": 182,
	"./components/Mobile/Account/UserMenu/PagePopup/": 182,
	"./components/Mobile/Account/UserMenu/PagePopup/index": 182,
	"./components/Mobile/Account/UserMenu/PagePopup/index.js": 182,
	"./components/Mobile/Account/UserMenu/index": 181,
	"./components/Mobile/Account/UserMenu/index.js": 181,
	"./components/Mobile/Account/Wallet": 249,
	"./components/Mobile/Account/Wallet/": 249,
	"./components/Mobile/Account/Wallet/TransactionList": 185,
	"./components/Mobile/Account/Wallet/TransactionList/": 185,
	"./components/Mobile/Account/Wallet/TransactionList/index": 185,
	"./components/Mobile/Account/Wallet/TransactionList/index.js": 185,
	"./components/Mobile/Account/Wallet/index": 249,
	"./components/Mobile/Account/Wallet/index.js": 249,
	"./components/Mobile/Account/index": 245,
	"./components/Mobile/Account/index.js": 245,
	"./components/Mobile/Alerts": 250,
	"./components/Mobile/Alerts/": 250,
	"./components/Mobile/Alerts/AlertList": 186,
	"./components/Mobile/Alerts/AlertList/": 186,
	"./components/Mobile/Alerts/AlertList/index": 186,
	"./components/Mobile/Alerts/AlertList/index.js": 186,
	"./components/Mobile/Alerts/index": 250,
	"./components/Mobile/Alerts/index.js": 250,
	"./components/Mobile/Auth": 251,
	"./components/Mobile/Auth/": 251,
	"./components/Mobile/Auth/ForgotPassword": 252,
	"./components/Mobile/Auth/ForgotPassword/": 252,
	"./components/Mobile/Auth/ForgotPassword/index": 252,
	"./components/Mobile/Auth/ForgotPassword/index.js": 252,
	"./components/Mobile/Auth/Login": 187,
	"./components/Mobile/Auth/Login/": 187,
	"./components/Mobile/Auth/Login/index": 187,
	"./components/Mobile/Auth/Login/index.js": 187,
	"./components/Mobile/Auth/Register": 253,
	"./components/Mobile/Auth/Register/": 253,
	"./components/Mobile/Auth/Register/index": 253,
	"./components/Mobile/Auth/Register/index.js": 253,
	"./components/Mobile/Auth/index": 251,
	"./components/Mobile/Auth/index.js": 251,
	"./components/Mobile/BookingRequest": 254,
	"./components/Mobile/BookingRequest/": 254,
	"./components/Mobile/BookingRequest/index": 254,
	"./components/Mobile/BookingRequest/index.js": 254,
	"./components/Mobile/Cart": 255,
	"./components/Mobile/Cart/": 255,
	"./components/Mobile/Cart/BillDetails": 188,
	"./components/Mobile/Cart/BillDetails/": 188,
	"./components/Mobile/Cart/BillDetails/index": 188,
	"./components/Mobile/Cart/BillDetails/index.js": 188,
	"./components/Mobile/Cart/CartCheckoutBlock": 189,
	"./components/Mobile/Cart/CartCheckoutBlock/": 189,
	"./components/Mobile/Cart/CartCheckoutBlock/index": 189,
	"./components/Mobile/Cart/CartCheckoutBlock/index.js": 189,
	"./components/Mobile/Cart/CartItems": 190,
	"./components/Mobile/Cart/CartItems/": 190,
	"./components/Mobile/Cart/CartItems/index": 190,
	"./components/Mobile/Cart/CartItems/index.js": 190,
	"./components/Mobile/Cart/Coupon": 191,
	"./components/Mobile/Cart/Coupon/": 191,
	"./components/Mobile/Cart/Coupon/index": 191,
	"./components/Mobile/Cart/Coupon/index.js": 191,
	"./components/Mobile/Cart/OrderComment": 192,
	"./components/Mobile/Cart/OrderComment/": 192,
	"./components/Mobile/Cart/OrderComment/index": 192,
	"./components/Mobile/Cart/OrderComment/index.js": 192,
	"./components/Mobile/Cart/RestaurantInfoCart": 120,
	"./components/Mobile/Cart/RestaurantInfoCart/": 120,
	"./components/Mobile/Cart/RestaurantInfoCart/index": 120,
	"./components/Mobile/Cart/RestaurantInfoCart/index.js": 120,
	"./components/Mobile/Cart/index": 255,
	"./components/Mobile/Cart/index.js": 255,
	"./components/Mobile/Checkout": 256,
	"./components/Mobile/Checkout/": 256,
	"./components/Mobile/Checkout/PaymentList": 193,
	"./components/Mobile/Checkout/PaymentList/": 193,
	"./components/Mobile/Checkout/PaymentList/VivaWallet/VivaWallet3dSecure": 337,
	"./components/Mobile/Checkout/PaymentList/VivaWallet/VivaWallet3dSecure.js": 337,
	"./components/Mobile/Checkout/PaymentList/VivaWallet/VivaWalletPayment": 336,
	"./components/Mobile/Checkout/PaymentList/VivaWallet/VivaWalletPayment.js": 336,
	"./components/Mobile/Checkout/PaymentList/index": 193,
	"./components/Mobile/Checkout/PaymentList/index.js": 193,
	"./components/Mobile/Checkout/index": 256,
	"./components/Mobile/Checkout/index.js": 256,
	"./components/Mobile/Elements/AlertPopUp": 333,
	"./components/Mobile/Elements/AlertPopUp.js": 333,
	"./components/Mobile/Elements/BackButton": 126,
	"./components/Mobile/Elements/BackButton.js": 126,
	"./components/Mobile/Elements/BackWithSearch": 38,
	"./components/Mobile/Elements/BackWithSearch.js": 38,
	"./components/Mobile/Elements/ConfirmationModal": 220,
	"./components/Mobile/Elements/ConfirmationModal.js": 220,
	"./components/Mobile/Elements/ContentLoader": 332,
	"./components/Mobile/Elements/ContentLoader.js": 332,
	"./components/Mobile/Elements/Meta": 219,
	"./components/Mobile/Elements/Meta.js": 219,
	"./components/Mobile/Elements/SocialButton": 137,
	"./components/Mobile/Elements/SocialButton.js": 137,
	"./components/Mobile/Explore": 257,
	"./components/Mobile/Explore/": 257,
	"./components/Mobile/Explore/ItemSearchList": 194,
	"./components/Mobile/Explore/ItemSearchList/": 194,
	"./components/Mobile/Explore/ItemSearchList/index": 194,
	"./components/Mobile/Explore/ItemSearchList/index.js": 194,
	"./components/Mobile/Explore/RestaurantSearch": 195,
	"./components/Mobile/Explore/RestaurantSearch/": 195,
	"./components/Mobile/Explore/RestaurantSearch/index": 195,
	"./components/Mobile/Explore/RestaurantSearch/index.js": 195,
	"./components/Mobile/Explore/RestaurantSearchList": 196,
	"./components/Mobile/Explore/RestaurantSearchList/": 196,
	"./components/Mobile/Explore/RestaurantSearchList/index": 196,
	"./components/Mobile/Explore/RestaurantSearchList/index.js": 196,
	"./components/Mobile/Explore/index": 257,
	"./components/Mobile/Explore/index.js": 257,
	"./components/Mobile/FirstScreen": 174,
	"./components/Mobile/FirstScreen/": 174,
	"./components/Mobile/FirstScreen/index": 174,
	"./components/Mobile/FirstScreen/index.js": 174,
	"./components/Mobile/FirstScreen/test-screen.png": 948,
	"./components/Mobile/FloatCart": 121,
	"./components/Mobile/FloatCart/": 121,
	"./components/Mobile/FloatCart/index": 121,
	"./components/Mobile/FloatCart/index.js": 121,
	"./components/Mobile/Footer": 66,
	"./components/Mobile/Footer/": 66,
	"./components/Mobile/Footer/index": 66,
	"./components/Mobile/Footer/index.js": 66,
	"./components/Mobile/GeoLocationPage": 258,
	"./components/Mobile/GeoLocationPage/": 258,
	"./components/Mobile/GeoLocationPage/GoogleMap": 197,
	"./components/Mobile/GeoLocationPage/GoogleMap/": 197,
	"./components/Mobile/GeoLocationPage/GoogleMap/index": 197,
	"./components/Mobile/GeoLocationPage/GoogleMap/index.js": 197,
	"./components/Mobile/GeoLocationPage/index": 258,
	"./components/Mobile/GeoLocationPage/index.js": 258,
	"./components/Mobile/GeoLocationPage/mapStyle": 222,
	"./components/Mobile/GeoLocationPage/mapStyle.json": 222,
	"./components/Mobile/Home": 198,
	"./components/Mobile/Home/": 198,
	"./components/Mobile/Home/PromoSlider": 94,
	"./components/Mobile/Home/PromoSlider/": 94,
	"./components/Mobile/Home/PromoSlider/index": 94,
	"./components/Mobile/Home/PromoSlider/index.js": 94,
	"./components/Mobile/Home/RestaurantList": 199,
	"./components/Mobile/Home/RestaurantList/": 199,
	"./components/Mobile/Home/RestaurantList/RangeSelectRestaurant": 200,
	"./components/Mobile/Home/RestaurantList/RangeSelectRestaurant/": 200,
	"./components/Mobile/Home/RestaurantList/RangeSelectRestaurant/index": 200,
	"./components/Mobile/Home/RestaurantList/RangeSelectRestaurant/index.js": 200,
	"./components/Mobile/Home/RestaurantList/index": 199,
	"./components/Mobile/Home/RestaurantList/index.js": 199,
	"./components/Mobile/Home/RestaurantListOnCategory": 259,
	"./components/Mobile/Home/RestaurantListOnCategory/": 259,
	"./components/Mobile/Home/RestaurantListOnCategory/index": 259,
	"./components/Mobile/Home/RestaurantListOnCategory/index.js": 259,
	"./components/Mobile/Home/index": 198,
	"./components/Mobile/Home/index.js": 198,
	"./components/Mobile/Items": 260,
	"./components/Mobile/Items/": 260,
	"./components/Mobile/Items/ChildItems": 202,
	"./components/Mobile/Items/ChildItems/": 202,
	"./components/Mobile/Items/ChildItems/index": 202,
	"./components/Mobile/Items/ChildItems/index.js": 202,
	"./components/Mobile/Items/Customization": 123,
	"./components/Mobile/Items/Customization/": 123,
	"./components/Mobile/Items/Customization/index": 123,
	"./components/Mobile/Items/Customization/index.js": 123,
	"./components/Mobile/Items/ItemList": 201,
	"./components/Mobile/Items/ItemList/": 201,
	"./components/Mobile/Items/ItemList/ItemBadge": 124,
	"./components/Mobile/Items/ItemList/ItemBadge/": 124,
	"./components/Mobile/Items/ItemList/ItemBadge/index": 124,
	"./components/Mobile/Items/ItemList/ItemBadge/index.js": 124,
	"./components/Mobile/Items/ItemList/RecommendedItems": 203,
	"./components/Mobile/Items/ItemList/RecommendedItems/": 203,
	"./components/Mobile/Items/ItemList/RecommendedItems/index": 203,
	"./components/Mobile/Items/ItemList/RecommendedItems/index.js": 203,
	"./components/Mobile/Items/ItemList/index": 201,
	"./components/Mobile/Items/ItemList/index.js": 201,
	"./components/Mobile/Items/RestaurantInfo": 125,
	"./components/Mobile/Items/RestaurantInfo/": 125,
	"./components/Mobile/Items/RestaurantInfo/index": 125,
	"./components/Mobile/Items/RestaurantInfo/index.js": 125,
	"./components/Mobile/Items/SingleItem": 261,
	"./components/Mobile/Items/SingleItem/": 261,
	"./components/Mobile/Items/SingleItem/index": 261,
	"./components/Mobile/Items/SingleItem/index.js": 261,
	"./components/Mobile/Items/index": 260,
	"./components/Mobile/Items/index.js": 260,
	"./components/Mobile/Location": 262,
	"./components/Mobile/Location/": 262,
	"./components/Mobile/Location/PopularPlaces": 204,
	"./components/Mobile/Location/PopularPlaces/": 204,
	"./components/Mobile/Location/PopularPlaces/index": 204,
	"./components/Mobile/Location/PopularPlaces/index.js": 204,
	"./components/Mobile/Location/index": 262,
	"./components/Mobile/Location/index.js": 262,
	"./components/Mobile/Nav": 122,
	"./components/Mobile/Nav/": 122,
	"./components/Mobile/Nav/index": 122,
	"./components/Mobile/Nav/index.js": 122,
	"./components/Mobile/RunningOrder": 263,
	"./components/Mobile/RunningOrder/": 263,
	"./components/Mobile/RunningOrder/Map": 205,
	"./components/Mobile/RunningOrder/Map/": 205,
	"./components/Mobile/RunningOrder/Map/GoogleMaps": 206,
	"./components/Mobile/RunningOrder/Map/GoogleMaps/": 206,
	"./components/Mobile/RunningOrder/Map/GoogleMaps/index": 206,
	"./components/Mobile/RunningOrder/Map/GoogleMaps/index.js": 206,
	"./components/Mobile/RunningOrder/Map/index": 205,
	"./components/Mobile/RunningOrder/Map/index.js": 205,
	"./components/Mobile/RunningOrder/index": 263,
	"./components/Mobile/RunningOrder/index.js": 263,
	"./components/Mobile/index": 173,
	"./components/Mobile/index.js": 173,
	"./components/NotFound": 264,
	"./components/NotFound/": 264,
	"./components/NotFound/index": 264,
	"./components/NotFound/index.js": 264,
	"./components/SinglePage": 265,
	"./components/SinglePage/": 265,
	"./components/SinglePage/index": 265,
	"./components/SinglePage/index.js": 265,
	"./components/helpers/AppSettings": 267,
	"./components/helpers/AppSettings.js": 267,
	"./components/helpers/DomModal": 221,
	"./components/helpers/DomModal.js": 221,
	"./components/helpers/calculateDistance": 108,
	"./components/helpers/calculateDistance.js": 108,
	"./components/helpers/calculateDistanceGoogle": 153,
	"./components/helpers/calculateDistanceGoogle.js": 153,
	"./components/helpers/debounce": 338,
	"./components/helpers/debounce.js": 338,
	"./components/helpers/delayLink": 34,
	"./components/helpers/delayLink.js": 34,
	"./components/helpers/formatPrice": 20,
	"./components/helpers/formatPrice.js": 20,
	"./components/helpers/generalActions": 27,
	"./components/helpers/generalActions.js": 27,
	"./components/helpers/history": 490,
	"./components/helpers/history.js": 490,
	"./components/helpers/loading": 25,
	"./components/helpers/loading.js": 25,
	"./components/helpers/menuItemsActions": 69,
	"./components/helpers/menuItemsActions.js": 69,
	"./components/helpers/meta": 30,
	"./components/helpers/meta.js": 30,
	"./components/helpers/vivaWalletPayment": 491,
	"./components/helpers/vivaWalletPayment.js": 491,
	"./configs": 14,
	"./configs/": 14,
	"./configs/index": 14,
	"./configs/index.js": 14,
	"./configs/website": 19,
	"./configs/website/": 19,
	"./configs/website/index": 19,
	"./configs/website/index.js": 19,
	"./index": 285,
	"./index.css": 951,
	"./index.js": 285,
	"./init-fcm": 271,
	"./init-fcm.js": 271,
	"./logo.svg": 952,
	"./serviceWorker": 307,
	"./serviceWorker.js": 307,
	"./services/Delivery/gpslocation/actionTypes": 134,
	"./services/Delivery/gpslocation/actionTypes.js": 134,
	"./services/Delivery/gpslocation/actions": 218,
	"./services/Delivery/gpslocation/actions.js": 218,
	"./services/Delivery/gpslocation/reducer": 492,
	"./services/Delivery/gpslocation/reducer.js": 492,
	"./services/addresses/actionTypes": 84,
	"./services/addresses/actionTypes.js": 84,
	"./services/addresses/actions": 83,
	"./services/addresses/actions.js": 83,
	"./services/addresses/reducer": 317,
	"./services/addresses/reducer.js": 317,
	"./services/alert/actionTypes": 85,
	"./services/alert/actionTypes.js": 85,
	"./services/alert/actions": 135,
	"./services/alert/actions.js": 135,
	"./services/alert/reducer": 320,
	"./services/alert/reducer.js": 320,
	"./services/cart/actionTypes": 71,
	"./services/cart/actionTypes.js": 71,
	"./services/cart/actions": 39,
	"./services/cart/actions.js": 39,
	"./services/cart/reducer": 325,
	"./services/cart/reducer.js": 325,
	"./services/checkout/actionTypes": 214,
	"./services/checkout/actionTypes.js": 214,
	"./services/checkout/actions": 127,
	"./services/checkout/actions.js": 127,
	"./services/checkout/reducer": 326,
	"./services/checkout/reducer.js": 326,
	"./services/confirmCart/actionTypes": 215,
	"./services/confirmCart/actionTypes.js": 215,
	"./services/confirmCart/actions": 107,
	"./services/confirmCart/actions.js": 107,
	"./services/confirmCart/reducer": 327,
	"./services/confirmCart/reducer.js": 327,
	"./services/coupon/actionTypes": 105,
	"./services/coupon/actionTypes.js": 105,
	"./services/coupon/actions": 334,
	"./services/coupon/actions.js": 334,
	"./services/coupon/reducer": 324,
	"./services/coupon/reducer.js": 324,
	"./services/items/actionTypes": 48,
	"./services/items/actionTypes.js": 48,
	"./services/items/actions": 49,
	"./services/items/actions.js": 49,
	"./services/items/reducer": 328,
	"./services/items/reducer.js": 328,
	"./services/languages/actionTypes": 131,
	"./services/languages/actionTypes.js": 131,
	"./services/languages/actions": 58,
	"./services/languages/actions.js": 58,
	"./services/languages/reducer": 313,
	"./services/languages/reducer.js": 313,
	"./services/locations/actionTypes": 213,
	"./services/locations/actionTypes.js": 213,
	"./services/locations/actions": 493,
	"./services/locations/actions.js": 493,
	"./services/locations/reducer": 322,
	"./services/locations/reducer.js": 322,
	"./services/notification/actionTypes": 209,
	"./services/notification/actionTypes.js": 209,
	"./services/notification/actions": 217,
	"./services/notification/actions.js": 217,
	"./services/notification/reducer": 311,
	"./services/notification/reducer.js": 311,
	"./services/orders/actionTypes": 70,
	"./services/orders/actionTypes.js": 70,
	"./services/orders/actions": 82,
	"./services/orders/actions.js": 82,
	"./services/orders/reducer": 315,
	"./services/orders/reducer.js": 315,
	"./services/pages/actionTypes": 98,
	"./services/pages/actionTypes.js": 98,
	"./services/pages/actions": 152,
	"./services/pages/actions.js": 152,
	"./services/pages/reducer": 319,
	"./services/pages/reducer.js": 319,
	"./services/paymentgateways/actionTypes": 216,
	"./services/paymentgateways/actionTypes.js": 216,
	"./services/paymentgateways/actions": 335,
	"./services/paymentgateways/actions.js": 335,
	"./services/paymentgateways/reducer": 330,
	"./services/paymentgateways/reducer.js": 330,
	"./services/popularLocations/actionTypes": 211,
	"./services/popularLocations/actionTypes.js": 211,
	"./services/popularLocations/actions": 342,
	"./services/popularLocations/actions.js": 342,
	"./services/popularLocations/reducer": 318,
	"./services/popularLocations/reducer.js": 318,
	"./services/promoSlider/actionTypes": 210,
	"./services/promoSlider/actionTypes.js": 210,
	"./services/promoSlider/actions": 341,
	"./services/promoSlider/actions.js": 341,
	"./services/promoSlider/reducer": 312,
	"./services/promoSlider/reducer.js": 312,
	"./services/rating/actionTypes": 132,
	"./services/rating/actionTypes.js": 132,
	"./services/rating/actions": 272,
	"./services/rating/actions.js": 272,
	"./services/rating/reducer": 316,
	"./services/rating/reducer.js": 316,
	"./services/reducers": 309,
	"./services/reducers.js": 309,
	"./services/restaurant/actionTypes": 86,
	"./services/restaurant/actionTypes.js": 86,
	"./services/restaurant/actions": 154,
	"./services/restaurant/actions.js": 154,
	"./services/restaurant/reducer": 329,
	"./services/restaurant/reducer.js": 329,
	"./services/searchRestaurants/actionTypes": 62,
	"./services/searchRestaurants/actionTypes.js": 62,
	"./services/searchRestaurants/actions": 99,
	"./services/searchRestaurants/actions.js": 99,
	"./services/searchRestaurants/reducer": 323,
	"./services/searchRestaurants/reducer.js": 323,
	"./services/settings/actionTypes": 208,
	"./services/settings/actionTypes.js": 208,
	"./services/settings/actions": 95,
	"./services/settings/actions.js": 95,
	"./services/settings/reducer": 310,
	"./services/settings/reducer.js": 310,
	"./services/store": 308,
	"./services/store.js": 308,
	"./services/total/actionTypes": 212,
	"./services/total/actionTypes.js": 212,
	"./services/total/actions": 97,
	"./services/total/actions.js": 97,
	"./services/total/reducer": 321,
	"./services/total/reducer.js": 321,
	"./services/user/actionTypes": 35,
	"./services/user/actionTypes.js": 35,
	"./services/user/actions": 29,
	"./services/user/actions.js": 29,
	"./services/user/reducer": 314,
	"./services/user/reducer.js": 314,
	"./services/vivaWallet/actionTypes": 133,
	"./services/vivaWallet/actionTypes.js": 133,
	"./services/vivaWallet/actions": 273,
	"./services/vivaWallet/actions.js": 273,
	"./services/vivaWallet/reducer": 331,
	"./services/vivaWallet/reducer.js": 331,
	"./setupTests": 494,
	"./setupTests.js": 494,
	"./styles/awesome-button.scss": 489,
	"./version": 268,
	"./version.json": 268,
	"./withTracker": 41,
	"./withTracker.js": 41
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 583;